module.exports = __webpack_public_path__ + "img/super-e45a80a2.png";